import { SelectPlus } from 'Components/SelectPlus';
import { useGetUsers } from '../hooks/useUsers';
import { getErrorMessage } from '@/shared/utils/errors/getErrorMessage';

export const SelectUser = ({ mode = 'single', ...selectProps }) => {
  const { data = [], isFetching, isError, error } = useGetUsers();

  const isSingleMode = mode === 'single';
  const placeholder = `Seleccionar usuario${isSingleMode ? '' : 's'}`;

  const options = data.map(record => ({
    value: record.id,
    label: record.fullName || record.username,
    record,
  }));

  return (
    <SelectPlus
      mode={mode}
      placeholder={placeholder}
      loading={isFetching}
      options={options}
      popupMatchSelectWidth // Hace que el menú desplegable tenga siempre el mismo ancho que el componente Select
      error={isError}
      errorMessage={getErrorMessage(error)}
      {...selectProps}
    />
  );
};